module.exports = __webpack_public_path__ + "media/images/vp/icon.menu.news.black-fc2a2cb0ecb9ddb3954905fdef3b1d32.svg";